/* eslint-disable consistent-return */
/* eslint-disable no-new */
/* eslint-disable func-names */
/* eslint-disable no-eval */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-use-before-define */
import UserCache from '@panda/cache/src/user/cache';

const userCache = new UserCache();

let hasRequiredUserInfo = false;
declare global {
  interface Window {
    Sentry: any;
    ip: string;
    ip_province: string;
    ip_city: string;
    ip_isp: string;
    dns: string;
    dns_province: string;
    dns_city: string;
  }
}

export interface RequestOption {
  url: string;
  method?: string;
  data?: {[index: string]: any};
  onload: Function;
  onerror: OnErrorEventHandler;
}

export const getWebUser = async () => {
  if (!hasRequiredUserInfo && !window.PandaNamespace.isLogin) {
    hasRequiredUserInfo = true;
    await userCache.getUserInfo({});
  }
  const { userInfo, userAccount } = window.PandaNamespace || {};
  if (userInfo) {
    return {
      id: userInfo.id,
      uid: userInfo.uid,
      loginId: userAccount.ydUserId,
      loginAccount: userAccount.loginAccount,
      loginType: userAccount.loginType,
      nickName: userInfo.nickName,
      realName: userInfo.realName,
      phoneNumber: userInfo.phoneNumber,
    };
  }
  return {
    id: +new Date(),
    loginAccount: '未登录用户',
    loginType: -9999,
    nickName: '未登录用户',
    realName: '未登录用户',
    phoneNumber: '未登录用户',
  };
};

export interface Browser {
  ua: string;
  dpr: number;
  plugins: string;
  itemTime: string;
}
export const getBrowser = () => {
  const browser: Browser = {
    ua: navigator.userAgent,
    dpr: window.devicePixelRatio,
    plugins: getPlugins().join('|'),
    itemTime: getItemTime(),
  };
  return browser;
};

export interface Network {
  ip: string;
  address: string;
  isp: string;
  dnsIp: string;
  dnsAddress: string;
}
export const network = (): Promise<Network> => new Promise((resolve) => {
  x.getJs({
    url: 'https://nstool.netease.com/info.js',
    onload() {
      resolve({
        ip: window.ip,
        address: `${window.ip_province} ${window.ip_city}`,
        isp: window.ip_isp,
        dnsIp: window.dns,
        dnsAddress: `${window.dns_province} ${window.dns_city}`,
      } as Network);
    },
    onerror() {
      resolve({
        ip: '获取失败',
        address: '获取失败',
        isp: '获取失败',
        dnsIp: '获取失败',
        dnsAddress: '获取失败',
      } as Network);
    },
  });
});

export enum DomainFetchType {
  IMAGE,
  JS,
  HEADER,
}
export interface Domain {
  host: string;
  resource: string;
  type: DomainFetchType;
}
export interface DomainConnectivity {
  host: string;
  isConnect: boolean;
  delay?: number;
  content?: string;
}
export const domainConnectivity = (servers: Domain[]) => fetchHostList(servers);

function fetchHostList(domains: Domain[]): Promise<DomainConnectivity>[] {
  return domains.map((domain) => new Promise((resolve) => {
    const time = new Date();
    const timeNumber = new Date().getTime();
    // 分钟级的缓存
    const timeString = `${time.getFullYear()
    }-${
      time.getMonth()
    }-${
      time.getDate()
    }-${
      time.getHours()
    }-${
      time.getMinutes()}`;
    const url = `${domain.host}${domain.resource}?time=${timeString}`;
    switch (domain.type) {
      case DomainFetchType.IMAGE:
        return x.getImg({
          url,
          onload() {
            resolve({
              host: domain.host,
              isConnect: true,
              delay: new Date().getTime() - timeNumber,
            });
          },
          onerror() {
            resolve({
              host: domain.host,
              isConnect: false,
            });
          },
        });
      case DomainFetchType.JS:
        return x.getJs({
          url,
          onload() {
            resolve({
              host: domain.host,
              isConnect: true,
              delay: new Date().getTime() - timeNumber,
            });
          },
          onerror() {
            resolve({
              host: domain.host,
              isConnect: false,
            });
          },
        });
      case DomainFetchType.HEADER:
        return x.getHeader({
          url,
          onload(headers: string) {
            resolve({
              host: domain.host,
              isConnect: true,
              delay: new Date().getTime() - timeNumber,
              content: headers,
            });
          },
          onerror() {
            resolve({
              host: domain.host,
              isConnect: false,
            });
          },
        });
      default:
        console.log(domain.type);
    }
  }));
}

function getPlugins() {
  return getRegularPlugins();
}

function getRegularPlugins() {
  const plugins = [];
  const pluginsArray = Array.from(navigator.plugins);

  for (let i = 0, len = pluginsArray.length; i < len; i += 1) {
    const plugin = pluginsArray[i] as Plugin;
    const pluginArr = Array.from(plugin);
    const mimeTypes = [];
    for (let j = 0, len2 = pluginArr.length; j < len2; j += 1) {
      mimeTypes.push([pluginArr[j].type, pluginArr[j].suffixes].join('~'));
    }
    plugins.push(
      [plugin.name, plugin.description, mimeTypes.join(',')].join('::'),
    );
  }
  return plugins;
}

function addPrefixZero(value: number) {
  return value < 10 ? `0${value}` : value.toString();
}

function getItemTime() {
  const date = new Date();
  const yyyy = date.getFullYear();
  const MM = addPrefixZero(date.getMonth() + 1);
  const dd = addPrefixZero(date.getDate());
  const HH = addPrefixZero(date.getHours());
  const mm = addPrefixZero(date.getMinutes());
  const ss = addPrefixZero(date.getSeconds());
  return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
}

const x = {
  get(opt: RequestOption) {
    opt.method = 'get';
    createReq(opt).submit();
  },
  post(opt: RequestOption) {
    opt.method = 'post';
    createReq(opt).submit();
  },
  getImg(opt: RequestOption) {
    const img = document.createElement('img');
    img.onload = opt.onload as (this: GlobalEventHandlers, ev: Event) => any;
    img.onerror = opt.onerror as OnErrorEventHandler;
    img.src = opt.url;
  },
  getJs(opt: RequestOption) {
    const secScript = document.createElement('script');
    secScript.setAttribute('type', 'text/javascript');
    secScript.setAttribute('src', opt.url);
    secScript.onload = opt.onload as (this: GlobalEventHandlers, ev: Event) => any;
    secScript.onerror = opt.onerror;
    document.body.insertBefore(secScript, document.body.lastChild);
  },
  getHeader(opt: RequestOption) {
    const req = new XMLHttpRequest();
    req.open('GET', opt.url, false);
    req.send(null);
    const headers = req.getAllResponseHeaders().toLowerCase();
    return opt.onload(
      headers
        .trim()
        .split(/[\r\n]+/)
        .join('<br/>'),
    );
  },
};

const createReq = (function () {
  function clearIframe(id: number) {
    setTimeout(() => {
      const iframe = document.getElementsByName(`iframe${id}`)[0];
      const form = document.getElementById(`form${id}`);
      if (iframe) {
        document.body.removeChild(iframe);
      }
      if (form) {
        document.body.removeChild(form);
      }
    }, 60000);
  }
  let id = 0;
  return function (opt: RequestOption) {
    const doc = document;
    const iframeName = `iframe${id}`;
    const bd = doc.body;
    const form = document.createElement('form');
    form.target = iframeName;
    form.id = `form${id}`;
    form.method = opt.method || 'get';
    form.action = opt.url;
    form.style.display = 'none';
    const param = opt.data;
    for (const key in param) {
      if (param.hasOwnProperty(key)) {
        const input = doc.createElement('input');
        input.name = key;
        input.value = param[key];
        form.appendChild(input);
      }
    }
    let iframe: HTMLIFrameElement;
    const onloadCb = (function (current) {
      return function () {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        let res = iframeDoc?.body.innerHTML;
        if (res) {
          res = eval(`(${res})`);
        }
        opt.onload(res);
        clearIframe(current);
      };
    }(id));
    const onerrorCb = (function (current) {
      return function () {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        let res = iframeDoc?.body.innerHTML;
        res = res && eval(`(${res})`);
        if (opt.onerror) {
          opt.onerror(res as string);
        }
        clearIframe(current);
      };
    }(id));
    iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.onload = onloadCb;
    iframe.onerror = onerrorCb;
    id += 1;
    iframe.style.display = 'none';
    bd.appendChild(form);
    bd.appendChild(iframe);
    return form;
  };
}());
